import { V9ReportParameter } from "../../shared-modules/reporting/models/v9-report-parameter.model";

export class MyReportsFolder {
    Id: Number;
    FolderName: string;
    FolderDescription: string;
    ReportsInFolder: ReportsInFolder[];

    // Non DTO field
    IsSelected: boolean;
}

export class ReportsInFolder {
    ReportId: Number;
    ReportFolderId: Number;
    ReportName: string;
    Description: string;


    Id: number;
    ParentId: number;
    ReportTitle: string;
    ReportType: number;
    Active: boolean;
    WorkflowReport: boolean;
    MinimumStudentsForWorkflow: number;
    ReportParameterClassName: string;
    StudentIds: string;
    ReportParameters: V9ReportParameter[];
    ReportValue: number;
    SchoolId: number;
    YearId: number;
    SiteSectionId: number;
}

// Assigned Reports Model

export class AssignedReports {
    Id: Number;
    FolderName: string;
    FolderDescription: string;
    NumberOfReports: Number;
    CreatedBy: string;
    CreatedOn: Date;

    AssignedReportsInFolder: AssignedReportInFolderDTO[];
    PermissionGroupsInFolder: PermissionGroupsInFolder[];
}

export class PermissionGroupsInFolder {
    PermissionGroupId: Number;
    ReportFolderId: Number;
    PermissionGroupName: string;
}

export class AssignedReportInFolderDTO {
    ReportId: Number;
    ReportFolderId: Number;
    ReportName: string;

    Description: string;
    Id: number;
    ParentId: number;
    ReportTitle: string;
    ReportType: number;
    Active: boolean;
    WorkflowReport: boolean;
    MinimumStudentsForWorkflow: number;
    ReportParameterClassName: string;
    StudentIds: string;
    ReportParameters: V9ReportParameter[];
    ReportValue: number;
    SchoolId: number;
    YearId: number;
    SiteSectionId: number;
}